<h2 class="form-title">{{ titleName }}</h2>

@if (loadingItems) {
<div class="loading">
  <app-loading-indicator />
</div>
}

<form
  (ngSubmit)="onSubmit()"
  [class.disabled]="loadingItems"
  id="addPlaylistForm"
>
  <div class="control" id="nameControl">
    <label for="name">Name</label>
    <input
      class="form-control"
      type="text"
      id="name"
      name="name"
      [(ngModel)]="enteredName"
    />
  </div>

  <div class="control" id="selectedItems">
    <label for="selectedItems">Items</label>
    <p-multiSelect
      name="selectedItems"
      autoWidth="false"
      [style]="{ width: '100%' }"
      appendTo="body"
      [options]="availableItems"
      [(ngModel)]="selectedItems"
      (onClick)="onSelectedItemsDropdownClick($event)"
      display="chip"
      placeholder="Select Items"
      id="selectedItemsDropdown"
      optionLabel="ProgramName || TargetName"
      [filter]="true"
      filterBy="ProgramName,TargetName"
    >
      <ng-template let-value pTemplate="selectedItems">
        <div
          class="inline-flex align-items-center gap-2 px-1"
          *ngFor="let option of value"
        >
          <div>{{ option.ProgramName ?? option.TargetName }},</div>
        </div>
        <div *ngIf="!value || value.length === 0">Select Items</div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.ProgramName ?? item.TargetName }}</div>
        </div>
      </ng-template>
      <ng-template let-country pTemplate="footer">
        <div class="py-2 px-3">
          <b>
            {{ selectedItems().length }}
          </b>
          item{{ selectedItems().length > 1 ? "s" : "" }}
          selected.
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="control" id="addPlaylistDetails">
    <label for="details">Playlist Instructions</label>

    <div class="editor-container editor-container_classic-editor">
      <div class="editor-container__editor">
        <div>
          <ckeditor
            id="details"
            name="details"
            [editor]="Editor"
            [config]="editorConfig"
            [data]="currentPlaylist?.Details ?? ''"
            (change)="onDetailsChange($event)"
          ></ckeditor>
        </div>
      </div>
    </div>
  </div>

  <div class="control">
    <label for="orderedItems">Selected Items</label>
    <div
      cdkDropList
      class="example-list"
      (cdkDropListDropped)="drop($event)"
      id="itemsOrdering"
    >
      @for (item of selectedItems(); track item) {
      <div class="example-box" cdkDrag>
        {{ item.ProgramName ?? item.TargetName }}
      </div>
      }
    </div>
  </div>

  <div class="actions d-flex justify-content-between" id="playlistActions">
    <button class="w-100 mx-2" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button class="w-100 mx-2" type="submit" id="savePlaylistButton">
      {{ actionName }}
    </button>
  </div>
</form>
